import React from "react";
import {
  TextWrapper,
  TransferTitle,
  TransferTitleSubTitle,
} from "../../template/AccountTransfer/FipayTransfer";
import { TransferTypeHeadingProps } from "../../template/AccountTransfer/data";

const TransferTypeHeading: React.FC<TransferTypeHeadingProps> = ({
  transferTitle,
  transferSubTitle,
}) => {
  return (
    <TextWrapper>
      <TransferTitle>{transferTitle}</TransferTitle>
      <TransferTitleSubTitle>{transferSubTitle}</TransferTitleSubTitle>
    </TextWrapper>
  );
};

export default TransferTypeHeading;
